<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          class="text-uppercase"
          :title="$t('message.imprint.title')"
          :icon="''"
        >
        </header-view>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col>
        <address>CodeCamp:N GmbH</address>
        <address>Solgerstr. 18</address>
        <address>90429 Nürnberg</address>
        <p>&nbsp;</p>
        <p>info [at] codecamp-n.com</p>
        <p>Tel.: +49 (0)911 / 27 44 85 23</p>

        <p>&nbsp;</p>

        <p>Geschäftsführer:</p>

        <p>Florian Zenk</p>

        <p>Bernhard Preuschoff</p>

        <p>Gerlinde Wanke</p>

        <p>&nbsp;</p>

        <p>Registernummer: HRB 34360</p>

        <p>Registergericht: Amtsgericht Nürnberg</p>

        <p>&nbsp;</p>

        <p>Umsatzsteuer-ID: DE133500778</p>

        <p>&nbsp;</p>

        <h4 class="text-uppercase">RECHTLICHE HINWEISE</h4>

        <p>&nbsp;</p>

        <p>
          Die Inhalte auf dieser Internetseite, der Hauptseite sowie allen
          Unterseiten werden sorgfältig erarbeitet und laufend gepflegt. Die
          CodeCamp:N GmbH ist dabei bemüht gemäß § 7 Abs. 1 Telemediengesetz
          (TMG) diese Inhalte vollständig und aktuell zu halten.
          Nichtsdestotrotz können fehlerhafte Inhalte enthalten sein, weshalb
          die CodeCamp:N GmbH keine Gewähr nach §§ 8 bis 10 TMG für
          Vollständigkeit, Aktualität und Richtigkeit der Inhalte übernimmt. Die
          Inhalte sollen nur der allgemeinen Information dienen und sind
          deswegen bewusst allgemein formuliert und stellen keine Beratung des
          Nutzers für den Einzelfall dar und können keine Einzelfallberatung
          ersetzen. Die CodeCamp:N GmbH haftet nicht für Schäden, die daraus
          resultieren, dass auf die Vollständigkeit, Aktualität und Richtigkeit
          der Inhalte dieser Internetseite vertraut wurde. Es sei denn der
          Schaden resultiert aus vorsätzlicher oder grob fahrlässiger
          Falschinformation. Diesbezüglich ist eine Haftung jedoch erst ab dem
          Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
          Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
          Inhalte umgehend entfernen. Die CodeCamp:N GmbH behält sich das Recht
          vor, jederzeit Änderungen, Ergänzungen oder Löschungen der Inhalte
          dieser Internetseite vorzunehmen.
        </p>

        <p>&nbsp;</p>

        <h4 class="text-uppercase">URHEBERRECHTE / MARKEN UND LOGOS</h4>

        <p>&nbsp;</p>

        <p>
          Die Inhalte und Werke auf dieser Internetseite, der Hauptseite sowie
          allen Unterseiten sind nach deutschem Urheberrecht geschützt. Ohne
          vorherige schriftliche Zustimmung der CodeCamp:N GmbH dürfen Inhalte,
          insbesondere Texte, Bilder, Grafiken etc., nicht genutzt oder
          verwendet werden. Dies gilt für jegliche Nutzungen, also ganz oder
          teilweise, privat oder kommerziell. Die Marken und Logos auf der
          Internetseite der CodeCamp:N GmbH sind urheberrechtlich geschützt.
          Ohne vorherige schriftliche Zustimmung der CodeCamp:N GmbH dürfen
          Marken oder Logos nicht genutzt werden. Dies gilt für jegliche
          Nutzungen, also ganz oder teilweise, privat oder kommerziell.
        </p>

        <p>&nbsp;</p>

        <h4 class="text-uppercase">
          HYPERLINKS UND VERWEISE AUF INTERNETSEITEN DRITTER
        </h4>

        <p>&nbsp;</p>

        <p>
          Wenn Sie Internetseiten Dritter aufrufen, verlassen Sie insoweit die
          Internetseite der CodeCamp:N GmbH. Die CodeCamp:N GmbH ist für den
          Inhalt von Internetseiten Dritter nicht verantwortlich. Die CodeCamp:N
          GmbH haftet nicht für den Inhalt von Internetseiten Dritter. Die
          CodeCamp:N GmbH übernimmt keine weitere Haftung für die
          Vollständigkeit, Aktualität oder Richtigkeit von Internetseiten
          Dritter, soweit hierauf mit einem Hyperlink oder sonstigem Verweis
          referenziert wird. Die CodeCamp:N GmbH macht sich die Inhalte der
          Internetseite Dritter nicht zu Eigen.
        </p>

        <p>&nbsp;</p>

        <p>
          Bei der erstmaligen Verknüpfung haben wir den fremden Inhalt
          genauestens überprüft. Jedoch trifft uns keine Verpflichtung zur
          laufenden Überprüfung auf Veränderung der Inhalte, auf die wir
          verweisen. Stellen wir jedoch fest, dass ein Inhalt einer fremden
          Seite, die wir verknüpft haben, eine zivil- oder strafrechtliche
          Verantwortlichkeit auslöst, werden wir den Link auf diese Seite
          aufheben, soweit uns dies möglich und zumutbar ist.
        </p>

        <p>&nbsp;</p>

        <p>
          Gerne nehmen wir Hinweise an, dass ein solcher Fall vorliegen könnte.
        </p>

        <p>&nbsp;</p>

        <p>Ihre CodeCamp:N GmbH</p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import HeaderView from '@/components/common/HeaderView'

export default {
  name: 'Imprint',
  components: {
    HeaderView
  }
}
</script>



// WEBPACK FOOTER //
// src/components/info/Imprint.vue